module.exports = __webpack_public_path__ + "img/jiamengBe.18796127.png";